import { Timeline, Avatar, Text, Flex } from "@mantine/core";
import dayjs from "dayjs";

export function WhiteboardCommentItem({ comment, dateTimeFormat }) {
    return (
        <Timeline.Item
            title={<Text fw={700}>{comment.user_name}</Text>}
            bullet={
                <Avatar
                    radius="xl"
                    size={32}
                    src={comment.avatar}
                    color="violet"
                >
                    {!comment.avatar && comment.user_name?.charAt(0).toUpperCase()}
                </Avatar>
            }
        >
            {/* Main comment text */}
            <Flex gap="xs" align="center">
                <Text ta="left" fw={400} fz={14} c="#4D4D4D" style={{ whiteSpace: "pre-line" }}>
                    {comment.comment}
                </Text>
            </Flex>

            {/* Date */}
            <Text ta="left" fw={400} fz={12} c="#39758D">
                {comment.created_at ? dayjs(comment.created_at).format(dateTimeFormat) : ""}
            </Text>

            {/* ✅ Render children recursively */}
            {comment.children && comment.children.length > 0 && (
                <Timeline
                    color="white"
                    bulletSize={28}
                    lineWidth={2}
                    style={{ marginTop: 12, marginLeft: 25 }}
                >
                    {comment.children.map((child) => (
                        <WhiteboardCommentItem
                            key={child.id}
                            comment={child}
                            dateTimeFormat={dateTimeFormat}
                        />
                    ))}
                </Timeline>
            )}
        </Timeline.Item>
    );
}
